var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 0h50a4 4 0 014 4v56a4 4 0 01-4 4H7a4 4 0 01-4-4V4a4 4 0 014-4z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4h44a3 3 0 013 3v50a3 3 0 01-3 3H10a3 3 0 01-3-3V7a3 3 0 013-3z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16c8.836 0 16 7.163 16 16 0 8.836-7.164 16-16 16-8.837 0-16-7.164-16-16 0-8.837 7.163-16 16-16zm-2.265 22.537a.8.8 0 001.131 0l8.568-8.568a.8.8 0 000-1.131l-1.272-1.272a.8.8 0 00-1.13 0l-6.732 6.73-3.331-3.331a.8.8 0 00-1.131 0l-1.272 1.272a.8.8 0 000 1.131l5.169 5.17z",
    fill: "#FF894F"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9Im5vbmUiIGQ9Ik0wIDBoNjR2NjRIMHoiLz48cGF0aCBkPSJNNyAwaDUwYTQgNCAwIDAgMSA0IDR2NTZhNCA0IDAgMCAxLTQgNEg3YTQgNCAwIDAgMS00LTRWNGE0IDQgMCAwIDEgNC00eiIgZmlsbD0iI0VCRUJFQiIvPjxwYXRoIGQ9Ik0xMCA0aDQ0YTMgMyAwIDAgMSAzIDN2NTBhMyAzIDAgMCAxLTMgM0gxMGEzIDMgMCAwIDEtMy0zVjdhMyAzIDAgMCAxIDMtM3oiIGZpbGw9IiNGRkYiLz48cGF0aCBkPSJNMzIgMTZjOC44MzYgMCAxNiA3LjE2MyAxNiAxNiAwIDguODM2LTcuMTY0IDE2LTE2IDE2LTguODM3IDAtMTYtNy4xNjQtMTYtMTYgMC04LjgzNyA3LjE2My0xNiAxNi0xNnptLTIuMjY1IDIyLjUzN2EuOC44IDAgMCAwIDEuMTMxIDBsOC41NjgtOC41NjhhLjguOCAwIDAgMCAwLTEuMTMxbC0xLjI3Mi0xLjI3MmEuOC44IDAgMCAwLTEuMTMgMGwtNi43MzIgNi43My0zLjMzMS0zLjMzMWEuOC44IDAgMCAwLTEuMTMxIDBsLTEuMjcyIDEuMjcyYS44LjggMCAwIDAgMCAxLjEzMWw1LjE2OSA1LjE3eiIgZmlsbD0iI0ZGODk0RiIvPjwvZz48L3N2Zz4=";
export { SvgTask as ReactComponent };